"use client"
import React from "react"

export default function FilterSearch({ text, search }: { text: string, search: string }) {
    if (!search) return text;
    // 转义特殊字符，避免正则表达式错误
    const escapedSearch = search.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const regex = new RegExp(`(${escapedSearch})`, 'gi');
    try {
        // 使用 split 分割，捕获组会将匹配的部分也包含在结果中
        const parts = text.split(regex);
        const searchLower = search.toLowerCase();
        return parts.map((part, i) => {
            // 检查当前部分是否匹配搜索词（不区分大小写）
            // split 使用捕获组时，匹配的部分会被包含在数组中
            const matches = part.toLowerCase() === searchLower && part.length > 0;
            return matches ? (
                <span key={i} className='text-blue-500 font-bold underline underline-offset-2'>{part}</span>
            ) : (
                <React.Fragment key={i}>{part}</React.Fragment>
        );
        });
    } catch (error) {
      return text;
    }
}
